import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { confirmPassword } from '../Accounts/API'
import EyeIcon from '../../../img/icon-eye.svg'

const Form = ({ token }) => {
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const navigate = useNavigate()

    const handleSubmit = async e => {
        e.preventDefault()

        const response = await confirmPassword(token, password).catch(err => {
            if (err.response.data.detail === 'Not found.') {
                return setError('This token has expired.')
            }
            if (err.response.data.password.length) {
                return setError(
                    err.response.data.password
                        .map(message => message.charAt(0).toUpperCase() + message.slice(1))
                        .join(' ')
                )
            }
            setError('There was a problem creating your account.')
        })

        if (response?.status === 200) {
            navigate('/')
        }
    }

    return (
        <div className="form-modal">
            <header>
                <h2>Create a new password for your account</h2>
                <p>Passwords must be at least eight characters long.</p>
            </header>
            <form method="post" onSubmit={handleSubmit}>
                {error && <p className="error">{error}</p>}
                <label htmlFor="password">
                    New password
                    <div className="text-input-container">
                        <input
                            id="password"
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                        <div className="input-buttons">
                            <button
                                type="button"
                                onClick={event => {
                                    event.preventDefault()
                                    setShowPassword(!showPassword)
                                }}
                            >
                                <EyeIcon className={showPassword ? 'dimmed' : ''} alt="Show/hide password" />
                            </button>
                        </div>
                    </div>
                </label>
                <button type="submit" className="button is-primary" disabled={password.length < 8}>
                    Set Password
                </button>
            </form>
        </div>
    )
}

Form.propTypes = {
    token: PropTypes.string.isRequired
}

export default Form
